import { useThemeContext } from '@/entities/theme/lib/context'
import ThemeIcon from '@/shared/assets/icons/theme.svg?react'
import { BaseSwitch } from '@/shared/components'

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeContext()
  const isDark = theme === 'dark'

  return (
    <div className="flex items-center justify-between w-full py-2">
      <div className="flex items-center gap-x-2">
        <ThemeIcon className="text-text-secondary dark:text-primary-dark" />
        <span className="w-24 text-sm font-medium text-text-secondary dark:text-primary-dark">
          {isDark ? 'Светлая тема' : 'Тёмная тема'}
        </span>
      </div>
      <BaseSwitch
        checked={isDark}
        onChange={toggleTheme}
        bgClassName={isDark ? 'bg-primary-dark' : 'bg-light-purple'}
        thumbClassName={isDark ? 'bg-white' : 'bg-text-secondary'}
      />
    </div>
  )
}
